// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

function handleModalClose() {

    this.onModalClose();

}

const SystemSelectedClaimsModalHeader = props =>
    <header className='system-selected-claims-modal-header'>
        <FormattedMessage
            id='SYSTEM_SELECTED_CLAIMS'
        />
        <span
            className='close-modal-icon'
            onClick={props::handleModalClose}
        />
    </header>;

SystemSelectedClaimsModalHeader.displayName = 'SystemSelectedClaimsModalHeader';
SystemSelectedClaimsModalHeader.propTypes = {
    onModalClose: PropTypes.func.isRequired
};

export default SystemSelectedClaimsModalHeader;



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/system-selected-claims-modal/system-selected-claims-modal-header.js